import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Form, Input, Row, Col, Switch } from 'antd'
import { MEETING_RESPONSE_STATUS } from '../../../../../utils/constants';


class AddMeeting extends Component {
	state = {
	}

	handleChangeInputExternal = (event, countId, field) => {
		const { attendees } = this.props.form.getFieldsValue()
		attendees[countId][field] = event.target.value;
		this.props.onChangeNameExternal(attendees, countId)
	}

	cardBox = (countAddBlock, countInviteExternal, countInviteExternalAll, isEditExternal, listDeleteInviteInternal, AddInviteInternal) => {
		const { getFieldDecorator } = this.props.form;
		let content = [];
		let countBlock = isEditExternal ? listDeleteInviteInternal.length : countAddBlock

		for (let index = 0; index < countBlock; index++) {

			let countIndex = countInviteExternal ? countInviteExternal + index + 1 : index + 1
			let countId = countInviteExternalAll + index + 1
			let name = ""
			let email = ""
			let isCheck = false


         // console.log("countBlock", isEditExternal)
         console.log("countBlock", AddInviteInternal[index])

			if (isEditExternal) {
				countIndex = AddInviteInternal[index]?.index
				countId = AddInviteInternal[index]?.code
				name = AddInviteInternal[index]?.Name
				email = AddInviteInternal[index]?.Email
            if(AddInviteInternal[index]?.asRole){
               isCheck = AddInviteInternal[index]?.asRole === "2" ? true : false
            }else{
               isCheck = AddInviteInternal[index]?.Status == 2 ? true : false
            }
			}

			content.push(
				<Col key={index} span={24} className={"box-add-external p-3 my-3"}>
					<div className={"box-number my-auto"}>
						<p className={"text-num-add"}>{countIndex}</p>
					</div>
					<Form.Item
						label={"ชื่อ-นามสกุล"}
						name={"name"}
						className="mb-0"
					>
						{getFieldDecorator(`attendees[${countId}].Name`, {
							initialValue: name,
							rules: [
								{
									required: true,
									message: 'กรุณากรอกชื่อ-นามสกุล',
								},
							],
							validateTrigger: 'onBlur'
						})(
							<Input
								// onChange={this.props.onChangeNameExternal}
								onChange={(event) => this.handleChangeInputExternal(event, countId, 'Name')}
							/>
						)}
					</Form.Item>

					<Form.Item
						label={"อีเมล"}
						name={"email"}
						className="mb-0"
					>
						{getFieldDecorator(`attendees[${countId}].Email`, {
							initialValue: email,
							rules: [
								{
									type: 'email',
									required: true,
									message: 'กรุณากรอกอีเมลให้ถูกต้อง',
								},
							],
							validateTrigger: 'onBlur'
						})(<Input
							// onChange={this.props.onChangeEmailExternal}
							onChange={(event) => this.handleChangeInputExternal(event, countId, 'Email')}
							placeholder="@sample"
						/>)}
					</Form.Item>
					<Row gutter={16} className={"pt-4 pb-3"}>
						<Col xs={{ span: 18, offset: 0 }}>
							<p>สถานะการตอบรับเข้าร่วมประชุม</p>
						</Col>
						<Col xs={{ span: 6, offset: 0 }} align="end">
							<Switch defaultChecked={isCheck} onChange={e => this.props.onChangeSwitchExternal(e, countId)} className={'switch-custom-antd'} />
						</Col>
					</Row>
				</Col>
			);
		}
		return content;
	}
	render() {
		const { countAddBlock, dataInvite, countInviteExternal, countInviteExternalAll, isEditExternal, listDeleteInviteInternal, AddInviteInternal } = this.props
		const { getFieldDecorator } = this.props.form;
		// console.log("dataInvite",dataInvite);
		return (
			<Row gutter={16} >
				{this.cardBox(countAddBlock, countInviteExternal, countInviteExternalAll, isEditExternal, listDeleteInviteInternal, AddInviteInternal)}
				<Col xs={{ span: 24, offset: 0 }}>

				</Col>
			</Row>
		)
	}
}


AddMeeting.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedAddMeeting = Form.create()(AddMeeting)

export default withApollo(WrappedAddMeeting)